import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogArticle = lazy(() => import('../pages/blog/article/page'));
const Arcachon = lazy(() => import('../pages/arcachon/page'));
const Bordeaux = lazy(() => import('../pages/bordeaux/page'));
const Merignac = lazy(() => import('../pages/merignac/page'));
const Pessac = lazy(() => import('../pages/pessac/page'));
const Talence = lazy(() => import('../pages/talence/page'));
const VillenaveOrnon = lazy(() => import('../pages/villenave-ornon/page'));
const SaintMedardJalles = lazy(() => import('../pages/saint-medard-jalles/page'));
const Begles = lazy(() => import('../pages/begles/page'));
const LaTesteBuch = lazy(() => import('../pages/la-teste-buch/page'));
const Libourne = lazy(() => import('../pages/libourne/page'));
const LeBouscat = lazy(() => import('../pages/le-bouscat/page'));
const Cenon = lazy(() => import('../pages/cenon/page'));
const Gradignan = lazy(() => import('../pages/gradignan/page'));
const Eysines = lazy(() => import('../pages/eysines/page'));
const GujanMestras = lazy(() => import('../pages/gujan-mestras/page'));
const Bruges = lazy(() => import('../pages/bruges/page'));
const Cestas = lazy(() => import('../pages/cestas/page'));
const Floirac = lazy(() => import('../pages/floirac/page'));
const Lormont = lazy(() => import('../pages/lormont/page'));
const Blanquefort = lazy(() => import('../pages/blanquefort/page'));
const AmbaresLagrave = lazy(() => import('../pages/ambares-lagrave/page'));
const LeHaillan = lazy(() => import('../pages/le-haillan/page'));
const SaintAndreCubzac = lazy(() => import('../pages/saint-andre-cubzac/page'));
const Mios = lazy(() => import('../pages/mios/page'));
const Biganos = lazy(() => import('../pages/biganos/page'));
const AndernosBains = lazy(() => import('../pages/andernos-bains/page'));
const Salles = lazy(() => import('../pages/salles/page'));
const Parempuyre = lazy(() => import('../pages/parempuyre/page'));
const CarbonBlanc = lazy(() => import('../pages/carbon-blanc/page'));
const ArtiguesBordeaux = lazy(() => import('../pages/artigues-bordeaux/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticle />,
  },
  {
    path: '/arcachon',
    element: <Arcachon />,
  },
  {
    path: '/bordeaux',
    element: <Bordeaux />,
  },
  {
    path: '/merignac',
    element: <Merignac />,
  },
  {
    path: '/pessac',
    element: <Pessac />,
  },
  {
    path: '/talence',
    element: <Talence />,
  },
  {
    path: '/villenave-ornon',
    element: <VillenaveOrnon />,
  },
  {
    path: '/saint-medard-jalles',
    element: <SaintMedardJalles />,
  },
  {
    path: '/begles',
    element: <Begles />,
  },
  {
    path: '/la-teste-buch',
    element: <LaTesteBuch />,
  },
  {
    path: '/libourne',
    element: <Libourne />,
  },
  {
    path: '/le-bouscat',
    element: <LeBouscat />,
  },
  {
    path: '/cenon',
    element: <Cenon />,
  },
  {
    path: '/gradignan',
    element: <Gradignan />,
  },
  {
    path: '/eysines',
    element: <Eysines />,
  },
  {
    path: '/gujan-mestras',
    element: <GujanMestras />,
  },
  {
    path: '/bruges',
    element: <Bruges />,
  },
  {
    path: '/cestas',
    element: <Cestas />,
  },
  {
    path: '/floirac',
    element: <Floirac />,
  },
  {
    path: '/lormont',
    element: <Lormont />,
  },
  {
    path: '/blanquefort',
    element: <Blanquefort />,
  },
  {
    path: '/ambares-lagrave',
    element: <AmbaresLagrave />,
  },
  {
    path: '/le-haillan',
    element: <LeHaillan />,
  },
  {
    path: '/saint-andre-cubzac',
    element: <SaintAndreCubzac />,
  },
  {
    path: '/mios',
    element: <Mios />,
  },
  {
    path: '/biganos',
    element: <Biganos />,
  },
  {
    path: '/andernos-bains',
    element: <AndernosBains />,
  },
  {
    path: '/salles',
    element: <Salles />,
  },
  {
    path: '/parempuyre',
    element: <Parempuyre />,
  },
  {
    path: '/carbon-blanc',
    element: <CarbonBlanc />,
  },
  {
    path: '/artigues-bordeaux',
    element: <ArtiguesBordeaux />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;